import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import LessonsTable from './LessonsTable'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { axiosInstance } from '../Config'
import secureLocalStorage from 'react-secure-storage'
import Loader from '../Loader'
import { Modal } from 'antd'
import { toast } from 'react-toastify'
import swal from 'sweetalert'
import moment from 'moment'
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import SlotSelection from './GetSlots'

const LessonsIndex = () => {

    const [data, setData] = useState([])
    const users = secureLocalStorage.getItem("credentials");
    const [allLessons, setAllLessons] = useState([])
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [lessonData, setLessonData] = useState({})
    const [activeTab, setActiveTab] = useState('all')
    const [currentlesson, setcurrentlesson] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0)
        getSessionsInfo()
    }, [])

    function getSessionsInfo() {
        setLoading(true)
        axiosInstance.post(`get-usrlesson`, {
            instructorid: users.id,
            type: 0,
        }, {
            headers: {
                Authorization: `Bearer ${users?.token}`
            }
        })
            .then(res => {
                setData(
                    res?.data?.lesson
                        .filter(lesson => lesson?.instacceptance !== "1")  // Filter out only "1" 
                );
                setAllLessons(res?.data?.lesson
                    .filter(lesson => lesson?.instacceptance !== "1")  // Filter out only "1" 
                )
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    const navigate = useNavigate()

    const filterCourses = (ftype) => {
        if (ftype) {
            setActiveTab(ftype)
            setData(allLessons.filter(item => item.cartype === ftype))
        } else {
            setActiveTab('all')
            setData(allLessons)
        }
    }
    const [items_perpage, setItemsPerPage] = useState(10)

    const total_pages = Math.ceil(data?.length / items_perpage);

    const final_data = data?.slice(page * items_perpage - items_perpage, page * items_perpage)

    const changePage = (pagecount) => {
        if (pagecount > 0 && pagecount <= total_pages) {
            setPage(pagecount)
            window.scrollTo(0, 0)
        }
    }

    const filterByName = (e) => {
        // console.log(allLessons)
        const filteredData = allLessons.filter((lesson) =>
            lesson?.user?.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
            lesson?.cources?.title.toLowerCase().includes(e.target.value.toLowerCase())
        )

        setData(filteredData)
    }


    const handleStatus = (id, value) => {
        swal({
            title: "Are you sure?",
            text: `You want to change status of this lesson.`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setLoading(true)

                    const formData = {
                        lessonid: id,
                        status: value,
                    }

                    axiosInstance.post('update-lessonstatus', formData, {
                        headers: {
                            Authorization: `Bearer ${users.token}`
                        }
                    })
                        .then((response) => {
                            if (response.data.success === true) {
                                swal("", "Lesson Status Changed Successfully", "success")
                                setTimeout(() => {
                                    getSessionsInfo();
                                }, 1000);
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                            swal("", "Something Went Wrong!", "error")
                        })
                        .finally(() => setLoading(false))
                }
            });
    }

    const [SlotsModal, setSlotsModal] = useState(false);
    const [SlotsDetails, setSlotsDetails] = useState([]);

    const [Status, setStatus] = useState('')
    const [QuestionModal, setQuestionModal] = useState(false);
    const [QuestionOne, setQuestionOne] = useState('')
    const [Questiontwo, setQuestiontwo] = useState('');
    const [CurrentSlot, setCurrentSlot] = useState();

    const handleSessionStatusChange = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);

            const formdata = new FormData()

            const combinedQuestions = [QuestionOne, Questiontwo];

            formdata.append("lessonId", currentlesson?.id)
            formdata.append("status", Number(Status))
            formdata.append("slotId", CurrentSlot)
            formdata.append("feedback", JSON.stringify(combinedQuestions))
            formdata.append("userType", 0)

            const respose = await axiosInstance.post("add-feedback", formdata, {
                headers: {
                    Authorization: `Bearer ${users.token}`
                }
            })

            if (respose?.data?.success === true && respose?.data?.message === "Feedback added successfully") {
                toast.success("Slot Details Updated");
                getSessionsInfo()
                setQuestionOne("")
                setQuestiontwo("")
            }
            else {
                toast.error("Something Went Wrong!");
            }
            setSlotsModal(false);
            setQuestionModal(false)
            setLoading(false)
        } catch (e) {
            console.log(e);
        }

    }

    useEffect(() => {
        if (currentlesson && currentlesson?.slots) {
            const slots = currentlesson?.slots;

            console.log("slots", currentlesson)

            // Check if 'slots' is a string
            if (typeof slots === 'string') {
                try {
                    //  slots.includes(`\\`) ? JSON.parse(JSON.parse(slots)) : 
                    const parsedSlots = JSON.parse(slots);
                    setSlotsDetails(parsedSlots);
                } catch (error) {
                    console.error("Error parsing JSON:", error);
                    // Handle error or set fallback value
                }
            } else if (Array.isArray(slots)) {
                // If 'slots' is already an array (valid JSON structure)
                setSlotsDetails(slots);
            } else {
                console.error("Unexpected format for slots:", slots);
                // Handle unexpected format, maybe set a default value
            }
        }
    }, [currentlesson]);

    const [StatusFilter, setStatusFilter] = useState('')

    const handleStatusFilter = (ftype) => {
        if (ftype) {
            const currrent = ftype === "pending" ? 0 : ftype === "in-progress" ? 1 : ftype === "finished" ? 2 : null;
            setStatusFilter(ftype)
            const data = allLessons.filter(item => item.status === currrent)
            setData(data)
        }
        else {
            setStatusFilter('')
            setData(allLessons)
        }
    }

    const [TimeModal, setTimeModal] = useState(false);
    const [endDate, setLastDate] = useState()
    const [timeSlot, setTimeSlot] = useState({
        date: moment(),
        time: ''
    })

    const handleDateChange = async () => {
        const Formdata = new FormData();

        if (timeSlot.date === '' && timeSlot.time === '') {
            toast.error("Please Select Date and Time to Proceed");
            return;
        }

        try {

            setLoading(true);

            Formdata.append("lessonId", currentlesson?.id);
            Formdata.append("slotId", CurrentSlot);
            Formdata.append("date", timeSlot.date);
            Formdata.append("time", timeSlot.time);

            const response = await axiosInstance.post("change-slot-timings", Formdata, {
                headers: {
                    Authorization: `Bearer ${users.token}`
                }
            })

            if (response.data.success === true) {
                setLoading(false);
                toast.success("Slot Date & Time Changed Successfully");
                getSessionsInfo();
            }

        } catch (e) {
            toast.error("Something Went Wrong");
            console.log("Error", e);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {
                loading && <Loader />
            }

            <ContainerDashboard title="All Lessons" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">

                        <div className="col-md-12 ">
                            <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>

                                <div className='d-md-flex justify-content-between align-items-start mb-4'>
                                    <div className="ps-section__search  d-flex justify-content-end mb-4">
                                        <div
                                            className="ps-form--search-simple"
                                        >
                                            <input
                                                className="form-control bg-white"
                                                type="text"
                                                placeholder="Search Lesson.."
                                                onChange={filterByName}
                                            />
                                            <button type='button'>
                                                <i className="icon icon-magnifier"></i>
                                            </button>
                                        </div>
                                        <select className='form-select ms-3 fs-5'
                                            value={items_perpage}
                                            onChange={(e) => setItemsPerPage(e.target.value)}
                                            style={{ width: '110px' }}>
                                            <option value="5">Show 5</option>
                                            <option value="10">Show 10</option>
                                            <option value="20">Show 20</option>
                                            <option value="30">Show 30</option>
                                        </select>

                                    </div>
                                    <div className='d-flex justify-content-end'>
                                        <div>
                                            <select className='form-select py-3 fs-5 me-md-2 '
                                                value={StatusFilter}
                                                onChange={(e) => handleStatusFilter(e.target.value)}
                                                style={{ width: '130px' }}>
                                                <option value="">All</option>
                                                <option value="pending">Pending</option>
                                                <option value="in-progress">In-Progress</option>
                                                <option value="finished">Finished</option>
                                            </select>
                                        </div>
                                        <div className='text-end'>
                                            <button type="button" onClick={() => navigate(-1)} className="button btn-black text-white ms-3">
                                                <i className='icon-arrow-left me-3 fs-5'></i>
                                                back</button>
                                        </div>
                                    </div>

                                </div>

                                <div className='mb-4 text-md-start text-center'>
                                    <button className={`button text-black mt-md-0 mt-4 fw-semibold bg-white rounded-4 ${activeTab === 'all' && 'active_course_tab'} me-md-3 me-2`}
                                        onClick={() => filterCourses()}>
                                        All ({allLessons.length})
                                    </button>
                                    <button className={`button text-black mt-md-0 mt-4 fw-semibold bg-white rounded-4 ${activeTab === 'Manual' && 'active_course_tab'} me-md-3 me-2`}
                                        onClick={() => filterCourses('Manual')}>
                                        Manual ({allLessons.filter(course => course.cartype === 'Manual').length})
                                    </button>
                                    <button className={`button text-black mt-md-0 mt-4 bg-white fw-semibold rounded-4 me-md-3 me-2 ${activeTab === 'Automatic' && 'active_course_tab'}`}
                                        onClick={() => filterCourses('Automatic')}>
                                        Automatic ({allLessons.filter(course => course.cartype === 'Automatic').length})
                                    </button>
                                </div>

                                <LessonsTable data={final_data}
                                    setData={setAllLessons}
                                    lessonData={lessonData}
                                    setLessonData={setLessonData}
                                    handleStatus={handleStatus}
                                    setcurrentlesson={setcurrentlesson}
                                    fetchdata={getSessionsInfo}
                                    setSlotsModal={setSlotsModal}
                                />

                                {/* pagination */}
                                <div className='d-flex flex-column align-items-end mt-5'>
                                    <p className='mb-4'>Show {final_data?.length} of {data?.length} items.</p>
                                    <div className='d-flex justify-content-md-start justify-content-center flex-wrap'>

                                        <div className={`bd-number-pagination rounded-2 me-3 mt-2`}
                                            onClick={() => changePage(page - 1)}>
                                            <i className='icon-arrow-left'></i>
                                        </div>

                                        {
                                            [...Array(total_pages)].map((_, pagecount) => {
                                                pagecount += 1
                                                return (
                                                    <div key={pagecount} className={`bd-number-pagination rounded-2 mx-1 pe-1 mt-2 ${page === pagecount && 'activepage'}`} onClick={() => changePage(pagecount)}>
                                                        {pagecount < 10 ? ('0' + pagecount) : pagecount}
                                                    </div>
                                                )
                                            })
                                        }

                                        <div className={`bd-number-pagination rounded-2 ms-3 mt-2`}
                                            onClick={() => changePage(page + 1)}>
                                            <i className='icon-arrow-right'></i>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <Modal
                        open={SlotsModal}
                        title="Lesson Slots Details"
                        centered
                        onCancel={() => setSlotsModal(false)}
                        width={700}
                        bodyStyle={{ padding: '0' }}
                        footer={null}
                    >
                        <div className="bg-gradientt p-4">
                            <div className='p-2 pb-0'>
                                {
                                    currentlesson?.user ?
                                        <div className="row mb-4">
                                            <div className='col-md-4'>
                                                <div className='bg-white px-3 py-2 rounded'>
                                                    <small>Student Name</small> <br />
                                                    <span>{currentlesson?.user?.name}</span>
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className='bg-white px-3 py-2 rounded'>
                                                    <small>Contact No.</small> <br />
                                                    <span>{currentlesson?.user?.mobile}</span>
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className='bg-white px-3 py-2 rounded'>
                                                    <small>Email Address</small> <br />
                                                    <span>{currentlesson?.user?.email}</span>
                                                </div>
                                            </div>
                                        </div> : null
                                }

                                <table className='table table-bordered' style={{ verticalAlign: 'middle' }}>
                                    <tbody>
                                        <tr>
                                            <th className='p-3'>Date</th>
                                            <th className='p-3'>Slot Time</th>
                                            <th className='p-3'>Status</th>
                                        </tr>
                                        {SlotsDetails &&
                                            SlotsDetails
                                                .sort((a, b) => {
                                                    // Convert date strings to moment objects for comparison
                                                    const dateA = moment(a?.date, "DD-MM-YYYY");
                                                    const dateB = moment(b?.date, "DD-MM-YYYY");
                                                    // Sort in descending order (latest date first)
                                                    return dateB.isBefore(dateA) ? 1 : -1;
                                                })
                                                .map((item, index) => (
                                                    <tr key={index}>
                                                        <td className='p-3'>{moment(item?.date, "DD-MM-YYYY").format("DD MMM, YYYY") || "--"}</td>
                                                        <td className='p-3'>{item?.time || "--"}</td>
                                                        <td className='p-3'>
                                                            <select value={item?.status}
                                                                className={`btn btn-light fs-5 text-${Number(item?.status) === 0 ? "green" : "red"}`}
                                                                disabled={moment(item?.date, "DD-MM-YYYY").isAfter(moment()) ||
                                                                    Number(item?.status) === 0}
                                                                onChange={(e) => {
                                                                    setStatus(e.target.value)
                                                                    setQuestionModal(true)
                                                                    setCurrentSlot(item?.id)
                                                                }}
                                                            >
                                                                <option value={1}>Not-Completed</option>
                                                                <option value={0}>Completed</option>
                                                            </select>
                                                            {moment(item?.date, "DD-MM-YYYY").isBefore(moment(), 'day') && Number(item?.status) === 1 && (
                                                                <button className="Date-button" onClick={() => {
                                                                    const lastDate = SlotsDetails[SlotsDetails.length - 1]?.date;
                                                                    setTimeModal(true)
                                                                    setCurrentSlot(item?.id)
                                                                    setLastDate(moment(lastDate, 'DD-MM-YYYY').toDate());
                                                                }}>Reschedule</button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Modal>

                    <Modal
                        open={QuestionModal}
                        title="Lesson Slots Questions"
                        centered
                        onCancel={() => setQuestionModal(false)}
                        width={500}
                        bodyStyle={{ padding: '0' }}
                        footer={null}
                    >
                        <div className="bg-gradientt p-4">
                            <div className='p-2 pb-0'>
                                <form onSubmit={handleSessionStatusChange}>
                                    <div className=''>
                                        <label htmlFor="" className=''>Is Student Come on Time Today?</label>
                                        <div className='row mt-3 m-0'>
                                            <div className='col-2 ps-0'>
                                                <div className='input-white-box Question-options'>
                                                    <input type="radio" required checked={QuestionOne === 'Yes'} onChange={(e) => setQuestionOne('Yes')} className='custom-radio-btn' name='licence' id='licence1' />
                                                    <label htmlFor="licence1" className='ms-2' >Yes</label>
                                                </div>
                                            </div>
                                            <div className='col-2'>
                                                <div className='input-white-box Question-options'>
                                                    <input type="radio" required checked={QuestionOne === 'No'} onChange={(e) => setQuestionOne('No')} className='custom-radio-btn' name='licence' id='licence2' />
                                                    <label htmlFor="licence2" className='ms-2'>No</label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="input-field mt-4 pt-3">
                                        <label htmlFor="screenshot" className='label'>Today's Experience
                                            <textarea type="text" id="screenshot"
                                                required
                                                className="text-area-input mt-2"
                                                value={Questiontwo}
                                                onChange={(e) => setQuestiontwo(e.target.value)}
                                                placeholder="" />

                                        </label>
                                    </div>
                                    <div className='col-md-12 mt-4'>
                                        <button type="submit" className="button btn-green color-white" >
                                            Submit</button>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </Modal>


                    <Modal
                        open={TimeModal}
                        title="Reschedule Lesson Slots"
                        centered
                        onCancel={() => setTimeModal(false)}
                        width={500}
                        bodyStyle={{ padding: '0' }}
                        footer={null}
                    >
                        <div className="bg-gradientt p-4">
                            <div className='p-2 pb-0'>
                                <SlotSelection id={users?.id} timeSlot={timeSlot} setTimeSlot={setTimeSlot} enddate={endDate} />
                                <button className='ms-2 button bg-green text-white mt-4 rounded-3' onClick={handleDateChange}>
                                    Update Date
                                </button>
                            </div>
                        </div>
                    </Modal>

                </section>
            </ContainerDashboard>
        </>
    )
}

export default LessonsIndex